import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "milestone",
  class: "container mx-auto px-4 py-20"
}
const _hoisted_2 = { class: "flex flex-col lg:flex-row gap-8 lg:gap-16 text-xl" }
const _hoisted_3 = { class: "lg:w-1/4 flex flex-row md:flex-col items-center md:h-72 justify-between" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "md:space-y-4 md:my-2 flex flex-row md:flex-col justify-center items-center" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "lg:w-3/4" }
const _hoisted_8 = { class: "relative w-full md:h-72 overflow-y-auto scrollbar-hide rounded-lg border-t border-gray-200 p-4 shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-1px_rgba(0,0,0,0.06),-1px_0_0_rgba(0,0,0,0.05),0_-1px_0_rgba(0,0,0,0.05)]" }
const _hoisted_9 = { class: "bg-white" }
const _hoisted_10 = { class: "flex items-start text-left" }
const _hoisted_11 = { class: "text-base font-semibold text-gray-500 mr-4 w-16" }
const _hoisted_12 = { class: "flex-1 text-sm" }
const _hoisted_13 = { class: "text-gray-800" }
const _hoisted_14 = {
  key: 0,
  class: "text-center py-12 text-gray-500"
}

import { ref, onMounted, computed } from "vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
// 注册模块（Swiper 9 必须）
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// swiper

export default /*@__PURE__*/_defineComponent({
  __name: 'cultureAndValues',
  setup(__props) {

SwiperCore.use([Pagination, Autoplay]);
// 引入样式
const swiperModules = [Pagination, Autoplay];



// 里程碑数据
// 响应式状态
const activeYear = ref(2025);
const currentIndex = ref(0);

// 数据
const years = [2025];
const milestones = [
  {
    year: 2025,
    month: "一月",
    content: "北境骑团宣布升级骑行战略，设立骑行优化目标。",
  },
  {
    year: 2025,
    month: "五月",
    content:
      "北境骑团启动“骑行生态伙伴”计划，助力人们在骑行中获得更好的生活体验。",
  },
];

// 计算属性
const currentYear = computed(() => years[currentIndex.value]);
const prevYear = computed(() => years[currentIndex.value - 1]);
const nextYear = computed(() => years[currentIndex.value + 1]);

const showPrevYear = computed(() => currentIndex.value > 0);
const showNextYear = computed(() => currentIndex.value < years.length - 1);

const isFirstGroup = computed(() => currentIndex.value === 0);
const isLastGroup = computed(() => currentIndex.value === years.length - 1);

const filteredMilestones = computed(() =>
  milestones.filter((item) => item.year === activeYear.value)
);

// 方法
const changeYear = (direction) => {
  if (direction === -1 && currentIndex.value > 0) {
    currentIndex.value--;
    activeYear.value = years[currentIndex.value];
  }

  if (direction === 1 && currentIndex.value < years.length - 1) {
    currentIndex.value++;
    activeYear.value = years[currentIndex.value];
  }
};

// 初始化
activeYear.value = currentYear.value;

onMounted(() => {
  // 这段代码的主要功能是根据用户在页面上的滚动位置动态地为导航栏添加或移除阴影效果。具体来说，
  // 当页面的垂直滚动距离大于 100 像素时，导航栏会显示一个中等大小的阴影，使其在页面滚动时更加突出，
  // 提升用户体验。当滚动距离小于或等于 100 像素时，阴影效果会被移除，从而使页面顶部看起来更加简洁。
  // window.addEventListener("scroll", () => {
  //   const nav = document.querySelector("nav");
  //   if (window.scrollY > 100) {
  //     nav?.classList.add("shadow-md");
  //   } else {
  //     nav?.classList.remove("shadow-md");
  //   }
  // });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[10] || (_cache[10] = _createStaticVNode("<section id=\"cultureAndValues\" class=\"py-20 bg-gray-50\" data-v-150a9ea4><div class=\"container mx-auto px-6\" data-v-150a9ea4><h2 class=\"text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4\" data-v-150a9ea4> 文化和价值观 </h2><div class=\"w-20 h-1 bg-yellow-400 mx-auto mb-6\" data-v-150a9ea4></div><p class=\"text-center text-gray-600 mb-16 max-w-3xl mx-auto\" data-v-150a9ea4> 这是一个源自骑行爱好者群体的品牌与平台，以联结伙伴、共享骑行乐趣为核心，传递善意与温暖，让每一份付出都能收获快乐。 </p><div class=\"grid grid-cols-1 md:grid-cols-2 gap-8 text-left\" data-v-150a9ea4><div class=\"row-span-2\" data-v-150a9ea4><h3 class=\"text-2xl font-bold mb-4\" data-v-150a9ea4>核心理念</h3><b data-v-150a9ea4>开放：</b> 以积极主动的心态拥抱一切可能，不设壁垒，欢迎所有对骑行感兴趣的人加入，共同探索未知的乐趣。<br data-v-150a9ea4><b data-v-150a9ea4>包容：</b>以宽阔的胸怀尊重差异，不论骑行经验、背景、风格如何，都能在群体中找到共处之道，彼此理解与支持。<br data-v-150a9ea4><b data-v-150a9ea4>接纳：</b>为每一位伙伴提供灵魂的归属，让大家在骑行中感受到被认可、被需要，形成紧密的情感联结。<br data-v-150a9ea4><b data-v-150a9ea4>探索：</b>以骑行为纽带突破边界，在未知旅程中发现自我与世界的更多可能，让每段路程都成为成长的契机。<br data-v-150a9ea4><b data-v-150a9ea4>共进：</b>汇聚个体力量形成前行合力，彼此赋能、相互成就，在骑行路上同步抵达更远的未来。 </div><div data-v-150a9ea4><h3 class=\"text-2xl font-bold mb-4\" data-v-150a9ea4>价值主张</h3> 强调 “善意与温暖的循环”：付出的善意终会以快乐形式回归，鼓励伙伴们在互动中传递正能量。 重视 “相遇的意义”：无论来自何方，只要因骑行相识，便珍惜这份缘分，不负遇见，携手同行。 </div><div data-v-150a9ea4><h3 class=\"text-2xl font-bold mb-4\" data-v-150a9ea4>愿景</h3> 骑行连接城乡，绿色驱动发展，创新迈向智慧未来。 </div></div></div></section>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4" }, " 里程碑 ", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-20 h-1 bg-yellow-400 mx-auto mb-6" }, null, -1)),
      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-center text-gray-600 mb-16 max-w-3xl mx-auto" }, " 这是一个源自骑行爱好者群体的品牌与平台，以联结伙伴、共享骑行乐趣为核心，传递善意与温暖，让每一份付出都能收获快乐。 ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeYear(-1))),
            class: _normalizeClass(["md:mb-4 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-primary hover:text-white transition-all duration-300", { 'opacity-50 cursor-not-allowed': isFirstGroup.value }]),
            disabled: isFirstGroup.value
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fa fa-chevron-up" }, null, -1)
          ]), 10, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            (showPrevYear.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (activeYear.value = prevYear.value)),
                  class: "cursor-pointer py-3 px-6 rounded-lg transition-all duration-300 hover:bg-secondary text-center text-lg font-medium text-gray-600"
                }, _toDisplayString(prevYear.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (activeYear.value = currentYear.value)),
              class: "cursor-pointer py-3 px-6 rounded-lg transition-all duration-300 bg-primary text-white text-center text-2xl font-bold shadow-md transform hover:scale-105 bg-yellow-400"
            }, _toDisplayString(currentYear.value), 1),
            (showNextYear.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (activeYear.value = nextYear.value)),
                  class: "cursor-pointer py-3 px-6 rounded-lg transition-all duration-300 hover:bg-secondary text-center text-lg font-medium text-gray-600"
                }, _toDisplayString(nextYear.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (changeYear(1))),
            class: _normalizeClass(["md:mt-4 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-primary hover:text-white transition-all duration-300", { 'opacity-50 cursor-not-allowed': isLastGroup.value }]),
            disabled: isLastGroup.value
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1)
          ]), 10, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMilestones.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "relative pl-8 py-3 transition-all duration-300"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.month), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(item.content), 1)
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (filteredMilestones.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 该年份暂无里程碑记录 "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _cache[11] || (_cache[11] = _createStaticVNode("<section id=\"leadershipTeam\" class=\"py-20 bg-gray-50\" data-v-150a9ea4><div class=\"container mx-auto px-6\" data-v-150a9ea4><h2 class=\"text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4\" data-v-150a9ea4> 领导团队 </h2><div class=\"w-20 h-1 bg-yellow-400 mx-auto mb-6\" data-v-150a9ea4></div><p class=\"text-center text-gray-600 mb-16 max-w-3xl mx-auto\" data-v-150a9ea4> 这是一个源自骑行爱好者群体的品牌与平台，以联结伙伴、共享骑行乐趣为核心，传递善意与温暖，让每一份付出都能收获快乐。 </p><div class=\"grid grid-cols-1 md:grid-cols-2 gap-8 text-left\" data-v-150a9ea4><div data-v-150a9ea4><h3 class=\"text-2xl font-bold mb-4\" data-v-150a9ea4>创始人</h3> 拥有 30 年骑行经验的资深爱好者，曾获环青海湖挑战赛冠军，如今是推动行业标准化的践行者。 始终坚信 “骑行是连接人与世界的最佳方式”，凭借对骑行文化的深刻理解，牵头搭建开放平台， 让每一份热爱都能找到生长的土壤。 </div><div data-v-150a9ea4><h3 class=\"text-2xl font-bold mb-4\" data-v-150a9ea4>首席运营官</h3> 在户外运动产业深耕十余年，善于将前沿理念转化为落地实践。主导的 “骑行生态伙伴计划”， 已联结 200 + 城市骑行社群，通过系统化运营，让 “包容共生” 的理念渗透到每一次蹬踏之间。 </div><div data-v-150a9ea4><h3 class=\"text-2xl font-bold mb-4\" data-v-150a9ea4>技术总监</h3> 曾是互联网大厂技术骨干，因一场川藏线骑行毅然转型。带领团队研发的智能骑行系统， 借助数据赋能让探索更具方向感，同时始终保留 “用车轮丈量大地” 的原始浪漫。 </div></div></div></section>", 1))
  ]))
}
}

})